import { DateTime } from "luxon";
import { CONFIG } from "../config";

export const codeFormatter = (data: any) => {
	if (data === null || data === undefined || data?.toString().trim() === "") {
		return "-";
	} else {
		return "#" + data;
	}
};

export const priceFormatter = (data: any) => {
	if (data === null || data === undefined || data?.toString().trim() === "") {
		return "-";
	} else {
		return Number(data).toFixed(2) + CONFIG?.CURRENCY;
	}
};

export const valueDateFormatter = (data: string) => {
	if (data === null) {
		return "-";
	} else {
		return new Date(data).toLocaleString(["en-GB"], {
			year: "numeric",
			month: "numeric",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		});
	}
};

export const getStartOfTheMonth = () => {
	const now = DateTime.now();

	const date = now.startOf("month").setLocale("en-gb").toLocaleString({
		day: "numeric",
		month: "numeric",
		year: "numeric",
	});
	return date;
};
export const getEndOfTheMonth = () => {
	const now = DateTime.now();

	const date = now.endOf("month").setLocale("en-gb").toLocaleString({
		day: "numeric",
		month: "numeric",
		year: "numeric",
	});
	return date;
};

export const thousandsFormatter = (data: any) => {
	if (data === null || data === undefined || data?.toString().trim() === "") {
		return "-";
	}
	return (
		new Intl.NumberFormat("en-US", {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		}).format(data) + CONFIG?.CURRENCY
	);
};
